module.exports = __webpack_public_path__ + "img/order.0f0870e0.svg";